import styled from "styled-components";
import { colors } from "../../../../styles/variables";

export const StyledQuantityWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  padding: 0 6px;
  height: 15px;
  background-color: ${colors.gray900};
`;

export const StyledQuantity = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${colors.white};
`;
